import { useMe } from "../data/user";
import { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { removeAuthToken } from "../client/token-utils";

interface PrivateRouteProps {
  children: ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthorized } = useMe();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthorized) {
      // Redirect to login page if not authorized
      removeAuthToken()
      navigate('/login', { 
        replace: true,
        state: { from: window.location.pathname } // Save the attempted path
      });
    }
  }, [isAuthorized, navigate]);

  // Don't render anything while redirecting
  if (!isAuthorized) {
    return null;
  }

  return <>{children}</>;
};

export default PrivateRoute;
